<template>
  <v-reports
    v-if="access.report_sale_by_payment"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
    Payment
  ></v-reports>
  <error404 v-else></error404>
</template>
<script>
import Currency from "../../mixins/settings/currency";
export default {
  name: "ReportsByPaymentType",
  mixins: [Currency],
  data: () => ({
    headers: [
      { text: "Payment type", value: "type", available: true, disabled: true },
      {
        text: "Payment transactions",
        value: "payment_transaction",
        available: true,
      },
      { text: "Payment amount", value: "payment_amount", available: true },
      {
        text: "Refund transactions	",
        value: "refund_transaction",
        available: true,
      },
      { text: "Refund amount", value: "refund_amount", available: true },
      { text: "Net amount", value: "net_amount", available: true },
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false,
    access: null,
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      const current_currency = this.current_currency;
      this.data_loading = true;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      var payments = this.$communicator.then(
        this,
        await this.$communicator("sales_by_payment", {
          arguments: [start_date, end_date],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees: params.employee._id != "" ? [params.employee._id] : [],
          },
        })
      );
      for (let i = 0; i < payments.length; i++) {
        payments[i].net_amount = (
          Math.round(payments[i].net_amount * current_currency) /
          current_currency
        ).toLocaleString();
        payments[i].payment_amount = (
          Math.round(payments[i].payment_amount * current_currency) /
          current_currency
        ).toLocaleString();
        payments[i].refund_amount = (
          Math.round(payments[i].refund_amount * current_currency) /
          current_currency
        ).toLocaleString();
      }
      this.data = payments;
      this.data_loading = false;
    },
  },
  mounted() {
    this.get_currency();
    this.current_currency = this.currentCurrency == "usd" ? 100 : 1;
    this.headers = [
      {
        text: this.$t(`payment_type`),
        value: "type",
        available: true,
        disabled: true,
      },
      {
        text: this.$t(`payment_transactions`),
        value: "payment_transaction",
        available: true,
      },
      {
        text: this.$t(`payment_amount`),
        value: "payment_amount",
        available: true,
      },
      {
        text: this.$t(`refund_transactions`),
        value: "refund_transaction",
        available: true,
      },
      {
        text: this.$t(`refund_amount`),
        value: "refund_amount",
        available: true,
      },
      { text: this.$t(`net_amount`), value: "net_amount", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
